import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import '../styles/portal.css';

const LOGO_URL = '/woss-publishing-assets/images/woss-publishing-logo-white.svg';

const NAV = [
  { to: '/app/portal/home',       label: 'Home',       icon: '⊞', end: true  },
  { to: '/app/portal/analytics',  label: 'Analytics',  icon: '◎', end: false },
  { to: '/app/portal/songs',      label: 'Songs',      icon: '♩', end: false },
  { to: '/app/portal/statements', label: 'Statements', icon: '≡', end: false },
  { to: '/app/portal/documents',  label: 'Documents',  icon: '□', end: false },
  { to: '/app/portal/help',       label: 'Help',       icon: '?', end: false },
  { to: '/app/portal/account',    label: 'Account',    icon: '○', end: false },
];

const ADMIN_NAV = [
  { to: '/app/portal/admin/roster',      label: 'Roster',      icon: '♫' },
  { to: '/app/portal/admin/invitations', label: 'Invitations', icon: '✉' },
  { to: '/app/portal/admin/users',       label: 'Users',       icon: '◉' },
];

function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

function isAdminUser(payload) {
  if (!payload) return false;
  const roles = Array.isArray(payload.roles) ? payload.roles : (payload.role ? [payload.role] : []);
  return roles.some(r => r === 'admin' || r === 'super_admin');
}

export default function PortalLayout() {
  const navigate = useNavigate();

  const token   = sessionStorage.getItem('wp_token');
  const payload = parseJwt(token);
  const isAdmin = isAdminUser(payload);

  const handleSignOut = () => {
    sessionStorage.removeItem('wp_token');
    navigate('/auth/login');
  };

  return (
    <div className="wp-portal">
      <aside className="wp-portal__sidebar">
        <div className="wp-portal__sidebar-header">
          <a href="/" className="wp-portal__brand">
            <img src={LOGO_URL} alt="Woss Publishing" style={{ height: '1.75rem', width: 'auto' }} />
          </a>
        </div>

        <nav className="wp-portal__nav" aria-label="Portal navigation">
          {NAV.map(({ to, label, icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `wp-portal__nav-link${isActive ? ' active' : ''}`
              }
            >
              <span className="wp-portal__nav-icon" aria-hidden="true">{icon}</span>
              {label}
            </NavLink>
          ))}

          {isAdmin && (
            <>
              <div className="wp-portal__nav-divider" aria-hidden="true" />
              <span className="wp-portal__nav-section-label">Admin</span>
              {ADMIN_NAV.map(({ to, label, icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  className={({ isActive }) =>
                    `wp-portal__nav-link${isActive ? ' active' : ''}`
                  }
                >
                  <span className="wp-portal__nav-icon" aria-hidden="true">{icon}</span>
                  {label}
                </NavLink>
              ))}
            </>
          )}
        </nav>

        <div className="wp-portal__signout">
          <button className="wp-portal__signout-btn" onClick={handleSignOut}>
            <span className="wp-portal__nav-icon" aria-hidden="true">→</span>
            Sign Out
          </button>
        </div>
      </aside>

      <div className="wp-portal__main">
        <div className="wp-portal__topbar">
          <span className="wp-portal__topbar-title">Woss Publishing Portal</span>
        </div>
        <div className="wp-portal__content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
